<template>
    <div style="min-height: 100vh" class="flex flex-direction">
        <Headers v-if="!$isMobileDevice" />
        <!-- class="flex-1 flex justify-center align-center" -->
        <div class="flex-1 flex justify-center">
            <!-- <div class="flex justify-center flex-direction main"> -->
            <!-- <div
                    class="bg-white b-r-8"
                    :class="{
                        'p-40': !$isMobileDevice,
                        'w-510': !$isMobileDevice
                    }"
                > -->
            <router-view></router-view>
            <!-- </div> -->
            <div v-if="routeName === 'Login' && false" class="m-t-21 relative">
                <img
                    class="w-510 h-134"
                    src="@/assets/user/download_icon.png"
                    alt=""
                />
                <vue-qr
                    class="qr_code"
                    :text="downloadQrcode"
                    :size="85"
                    :margin="2"
                    color-dark="#000"
                />
            </div>
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
import { Headers } from '@/layout/components';
import VueQr from 'vue-qr';
export default {
    components: {
        Headers,
        VueQr
    },
    data() {
        return {
            routeName: this.$route.name,
            downloadQrcode: ''
        };
    },
    watch: {
        $route: {
            handler(route) {
                this.routeName = route.name;
                console.log(this.routeName, 'this.routeName');
            },
            immediate: true
        }
    }
};
</script>
<style lang="scss" scoped>
.qr_code {
    border-radius: 4px;
    position: absolute;
    top: 25px;
    right: 22px;
}
.bg-fff {
    background: #fff;
}
.main {
    height: calc(100vh - 64px);
}
</style>
